import styled from 'styled-components';

const RecordingWrapper = styled.div`
    min-width: 56px;
    display: flex;
    align-items: center;
`;

export default RecordingWrapper;
